import React, { useEffect } from 'react';

import styles from './GameBannerList.module.less';
import Header from '../../components/GameHeader/GameHeader';
import GameLink from '../../components/GameLink/GameLink';
import { useInView } from 'react-intersection-observer';

export default ({ data: dataSource, logInfo }) => {
  const { title, operate, to, tag: source, data = [], targetType } = dataSource || {};
  const [ref, inView] = useInView({
    threshold: 1,
  });

  useEffect(() => {
    if (inView && logInfo && logInfo.changView) {
      logInfo.changView({
        pageCardId:
          dataSource &&
          dataSource.dataList &&
          dataSource.dataList[0] &&
          dataSource.dataList[0].pageCardContentId,
        pageCardTitle: dataSource && dataSource.title,
        rankCode:
          dataSource &&
          dataSource.dataList &&
          dataSource.dataList[0] &&
          dataSource.dataList[0].code,
        cardType: dataSource && dataSource.cardType,
        org:
          dataSource && dataSource.dataList && dataSource.dataList[0] && dataSource.dataList[0].org,
      });
    }
  }, [inView]);

  if (!['1', '2', '3', '5', '10', '11', '12'].includes(targetType)) {
    return null;
  }
  return (
    <div className={styles.BannerList} ref={ref}>
      <Header title={title} operate={operate === '2' ? '2' : '0'} to={to} source={source} />
      <nav>
        {data.map(banner => {
          return (
            <GameLink
              key={banner.pageCardContentId}
              info={banner}
              source={source}
              logInfo={{
                category: 'C',
                action: 'Game_Non_Button',
                params: {
                  id: banner.pageCardContentId || '',
                  type: 'zt',
                  source,
                },
                bizInfo: banner.bizInfo,
              }}
            >
              <header>
                <b style={{ backgroundImage: `url("${banner.contentImg}")` }} />
              </header>
            </GameLink>
          );
        })}
      </nav>
    </div>
  );
};
